<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.name }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CourierTabLinks />
                    <CourierCard :entity="entity" />
                </CCardBody>

                <CCardFooter>
                    <CButton
                        class="mr-2"
                        :color="entity.online ? 'danger' : 'primary'"
                        @click="setWorkStatus"
                    >{{ entity.online ? 'Звершить смену' : 'Начать смену' }}</CButton>
                    <CButton
                        class="mr-2"
                        :color="entity.at_lunch ? 'danger' : 'primary'"
                        :disabled="!entity.online"
                        @click="setLunch"
                    >{{ entity.at_lunch ? 'Звершить перерыв' : 'Начать перерыв' }}</CButton>
                    <CButton
                        class="mr-2"
                        color="danger"
                        @click="resetCourier"
                    >Сброс данных</CButton>
                    <CButton
                        color="primary"
                        @click="$router.push(`/couriers`)"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import CourierTabLinks from '@/components/couriers/CourierTabLinks';
    import CourierCard from '@/components/couriers/CourierCard';

    export default {
        name: 'Courier',

        components: {
            CourierTabLinks,
            CourierCard,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/couriers/${id}`)).data;
            },

            async setWorkStatus () {
                const { id } = this.$route.params;
                this.entity = (await this.axios.post(`/couriers/${id}/work-status`, { online: !this.entity.online })).data;
                await this.fetch();
            },

            async setLunch () {
                const { id } = this.$route.params;
                this.entity = (await this.axios.post(`/couriers/${id}/lunch-status`, { at_lunch: !this.entity.at_lunch })).data;
                await this.fetch();
            },

            async resetCourier () {
                const { id } = this.$route.params;
                this.entity = await this.axios.post(`/couriers/reset/${id}`);
                await this.fetch();
            }
        },
    };
</script>
